import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: auto;
	border-radius: 5px;
	padding: 1.5rem;
	background-color: ${color.interface.white};
`;

export const header = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 0.5fr;

	@media (max-width: 750px) {
		grid-template-columns: 200px 200px 200px 100px;
		/* scrollbar-width: none;
		-ms-overflow-style: none;  */
	}

	> p {
		font-size: 1.5rem;
		color: ${color.interface.darkgray};
		font-weight: 900;
		font-family: nunito-bold;
	}
`;

export const line = styled.div`
	min-width: 100%;
	min-height: 1px;
	background-color: ${color.interface.lightGray2};
	margin: 1rem 0;

	@media (max-width: 750px) {
		width: 700px;
	}
`;

export const centralize = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const noUsers = styled.p`
	font-size: 1.5rem;
	color: ${color.interface.lightGray};
`;

export const list = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
`;

export const itemList = styled.div`
	width: 100%;
	min-height: fit-content;
	display: grid;
	gap: 1rem;
	grid-template-columns: 1fr 1fr 1fr 0.5fr;
	align-items: center;
	justify-items: flex-start;
	/* overflow-y: hidden;
	overflow-x: auto; */

	> p {
		width: 100%;
		font-size: 1.5rem;
		color: ${color.interface.darkgray};
		opacity: 0.8;
	}

	@media (max-width: 750px) {
		grid-template-columns: 200px 200px 200px 100px;
		/* scrollbar-width: none;
		-ms-overflow-style: none;  */
	}
`;

export const emailAndName = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	align-items: flex-start;
	justify-content: center;
	> p {
		font-size: 1.5rem;
		color: ${color.interface.darkgray};
		opacity: 0.8;
	}

	> label {
		font-size: 1.3rem;
		opacity: 0.3;
	}
`;

export const actions = styled.div`
	display: flex;
	gap: 1.5rem;
`;

// export const exempleStyled = styled(estiloCriado).withConfig({
// 	shouldForwardProp: (prop) => !['nomeDaProps'].includes(prop)
// })``;
